export const MyTeamsProfileDepartmentReducer = (state = {}, action) => {
    if (action.type === 'GET_UPG_MY_TEAM_PROFILE_DEPARTMENT') {
      return {
        ...state,
        myTeamsProfileDepartmentOption: action.payload,
      };
    } else {
      return state;
    }
  };